import {css, StyleSheet} from 'aphrodite';
import React, {ReactNode} from 'react';

import {HALTED_VIEW_ICON} from 'analysis-tool/data-view/AnalysisViewUtils';
import {assertAndContinue} from 'Asserts';
import {PipelineStepStatusCode} from 'graphql-client/__generated/graphqlGlobalTypes';
import {FONT_PROXIMA_16} from 'styles/FontConstants';
import getTestProps from 'test/lib/cypress/getTestProps';
import {GRAY_DARK, GRAY_LIGHT} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import {AnalysisMainViewItemType, MainViewComponentProps} from './MainViewTypes';

interface HaltedStepContentProps {
  statusMessage?: string | null;
  action?: ReactNode;
}

export function HaltedStepContent({statusMessage, action}: HaltedStepContentProps): JSX.Element {
  return (
    <>
      <BenchlingIcon icon={HALTED_VIEW_ICON} className={css(haltedContentStyles.icon)} />
      <p className={css(haltedContentStyles.text)}>Halted</p>
      {statusMessage != null && <p className={css(haltedContentStyles.text)}>{statusMessage}</p>}
      {action}
    </>
  );
}

export const haltedContentStyles = StyleSheet.create({
  icon: {
    color: GRAY_LIGHT,
    height: '60px',
    width: '60px',
  },
  text: {
    ...FONT_PROXIMA_16,
    color: GRAY_DARK,
    margin: 0,
  },
});

export default function HaltedStepView({
  step,
}: MainViewComponentProps<AnalysisMainViewItemType.HALTED>): JSX.Element {
  assertAndContinue(
    step.statusCode === PipelineStepStatusCode.HALTED,
    `Expected to only use this component with ${PipelineStepStatusCode.HALTED} steps`,
    {statusCode: step.statusCode, stepId: step.id, stepType: step.definition.stepType}
  );

  return (
    <div className={css(styles.wrapper)} {...getTestProps({component: 'HaltedStepView', element: 'root'})}>
      <HaltedStepContent />
    </div>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    gap: 12,
  },
});
